import React, { useState } from "react";
import { Button } from "react-bootstrap";

import Faq from "./Faq";
import useInput from "../../../utils/useInput";

const CallBack = () => {
  const [name, bindName, resetName] = useInput("");
  const [email, bindEmail, resetEmail] = useInput("");
  const [subject, bindSubject, resetSubject] = useInput("");
  const [phoneNo, bindPhoneNo, resetPhoneNo] = useInput("");
  const [message, bindMessage, resetMessage] = useInput("");

  const [feedback, setFeedback] = useState(null);

  const FormSubmitHandler = async function (e) {
    e.preventDefault();
    let enquiry = { name, email, phoneNo, subject, message };

    await fetch("https://atease-insurance.herokuapp.com/user/enquiry", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(enquiry),
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.status === "FAILED") {
          setFeedback(data.message);
          setTimeout(() => {
            setFeedback(null);
          }, 3000);
        } else {
          if (data.status === "SUCCESS") {
            setFeedback(data.message);
            resetName();
            resetEmail();
            resetSubject();
            resetPhoneNo();
            resetMessage();
            setTimeout(() => {
              setFeedback(null);
            }, 3000);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      <section className="callback__section">
        <div className="container">
          <div className="row pt-5 pb-3">
            <div className="col-md-6">
              <div className="faq-content">
                <h2 className="h2-title">Request A Call Back</h2>

                <form>
                  <div className="row">
                    <div className="col-md-6 col-xl-6 col-sm-6 mb-2">
                      <div className="form-group text__input">
                        <label for="name" className="mb-1">
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Name"
                          {...bindName}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-6 col-sm-6 mb-2">
                      <div className="form-group">
                        <label for="email" className="mb-1">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email"
                          {...bindEmail}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-6 col-sm-6 mb-2">
                      <div className="form-group">
                        <label for="subject" className="mb-1">
                          Subject
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Subject"
                          {...bindSubject}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-6 col-sm-6 mb-2">
                      <div className="form-group">
                        <label for="phone" className="mb-1">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Phone Number"
                          {...bindPhoneNo}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-xl-12 col-sm-12 mb-2">
                      <div className="form-group">
                        <label for="message" className="mb-1">
                          Message
                        </label>
                        <textarea
                          className="form-control"
                          placeholder="Message"
                          {...bindMessage}
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  {feedback && (
                    <p className="d-flex justify-content-center">{feedback}</p>
                  )}

                  <Button
                    className="mb-2 justify-content-md-center pt-2 "
                    variant="outline-dark"
                    size="lg"
                    // href="/"
                    onClick={FormSubmitHandler}
                  >
                    Submit
                  </Button>
                </form>
              </div>
            </div>
            <div className="col-md-6">
              <Faq />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CallBack;
